/* unplugin-vue-components disabled */import { render } from "./SettingsPlatform.vue?vue&type=template&id=650311d0&scoped=true&ts=true"
import script from "./SettingsPlatform.vue?vue&type=script&lang=ts"
export * from "./SettingsPlatform.vue?vue&type=script&lang=ts"

import "./SettingsPlatform.vue?vue&type=style&index=0&id=650311d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650311d0"]])

export default __exports__